<template>
  <div class="wrap">
      <wedHd></wedHd>
        <div class="head_img">
            <img src="@/assets/images/wap/vdwap.png" alt="">
        </div>
        <div class="ct_box">
            <div class="advantage_box">
                <div class="titleBox">产品优势</div>
                <ul class="content">
                    <li class="lis_box">
                        <div class=" flex1">
                            <p class="til">超强用户互动体验</p>
                            <p class="text">多媒体内容，链接跳转、个性通知、营销贴尾</p>
                        </div>
                        <div class=" flex2">
                            <img src="@/assets/images/wap/VDadvantage1.png" alt="">
                        </div>
                    </li>
                    <li class="lis_box">
                        <div class=" flex1">
                            <p class="til">高效运营审核能力</p>
                            <p class="text">运营及时响应内容报备，高效审核能力，并提供专业的营销咨询及投递方案建议</p>
                        </div>
                        <div class=" flex2">
                            <img src="@/assets/images/wap/VDadvantage2.png" alt="">
                        </div>
                    </li>
                    <li class="lis_box">
                        <div class=" flex1">
                            <p class="til">低门槛高到达率</p>
                            <p class="text">无需下载APP或者关注公众号，即可收到视频短信</p>
                        </div>
                        <div class=" flex2">
                            <img src="@/assets/images/wap/VDadvantage3.png" alt="">
                        </div>
                    </li>
                </ul>
            </div>
            <div class="scenario_box">
                <div class="titleBox">应用场景</div>
                <div class="scenario_ct">
                    <div class="cil_til">1、金融行业</div>
                    <p class="cli_text">适用场景： 活动营销、积分回馈、账单还款提醒、APP推广、会员专享、互动抽奖</p>
                    <div class="img_box">
                        <img src="@/assets/images/wap/VDscenario1.png" alt="">
                    </div>
                </div>
                <div class="scenario_ct">
                    <div class="cil_til">2、电商行业</div>
                    <p class="cli_text">适用场景：节日大促、新品推荐、商品直购、会员回馈、商品限时开抢、拼团提醒、预购提醒、领取津贴礼券、服务通知</p>
                    <div class="img_box">
                        <img src="@/assets/images/wap/VDscenario2.png" alt="">
                    </div>
                </div>
                <div class="scenario_ct">
                    <div class="cil_til">3、餐饮行业</div>
                    <p class="cli_text">适用场景：准点抢购、新品上线打折、活动预订、优惠券赠送、消费提醒、附近商家推荐、会员回馈、用户调查</p>
                    <div class="img_box">
                        <img src="@/assets/images/wap/VDscenario3.png" alt="">
                    </div>
                </div>
            </div>
        </div>
      <wedFt></wedFt>
  </div>
</template>

<script>
import wedHd from '@/components/wepHearder.vue'
import wedFt from '@/components/wefot.vue'
export default {
    components:{
        wedHd,
        wedFt,
    },

}
</script>

<style scoped>
.wrap{
    background: #f4f5f6;
}
.head_img img{
    width: 100%;
    object-fit: cover;
}
.titleBox{
    width: 100%;
    height: 58px;
    line-height: 58px;
    color: #1C2A39;
    font-size: 20px;
    background: url(../../assets/images/wap/title.png) no-repeat left top;
    background-size:29px;
    padding-left: 15px;
    /* border-bottom: 1px solid #EDEEF0; */
}
.advantage_box{
    background-color: #fff;
}
.content li{
    display: flex;
}
.content .lis_box{
    padding: 0.4rem 0.6rem;
}
.content .flex1{
    flex: 15;
}
.content .flex2{
    flex: 9;
}
.content .flex2 img{
    width: 100%;
}
.content .flex1 .til{
    font-size: 0.43rem;
    margin-bottom: 0.19rem;
    color: #1C2A39;
    font-weight: bold;
}
.content .flex1 .text{
    font-size: 0.37rem;
    color: #4D5865;
    padding-right: 0.3rem;
    line-height: 1.5;
}
.scenario_box{
    background-color: #fff;
    margin-top: 10px;
}
.scenario_box .scenario_ct{
    padding:0 0.55rem;
    margin-top: 0.96rem;
}
.scenario_box .scenario_ct .cil_til{
    font-size: 0.4rem;
    font-weight: bold;
    
}
.scenario_box .scenario_ct .cli_text{
    color: #4D5865;
    font-size: 0.37rem;
    margin-bottom: 0.53rem;
    margin-top: 0.21rem;
    line-height: 1.5;
}
.scenario_box .scenario_ct .img_box{
    text-align: center;
}
.scenario_box .scenario_ct .img_box img{
    width: 90%;
    /* margin-bottom: -2px; */
    vertical-align: bottom;
}


</style>


// WEBPACK FOOTER //
// src/pages/wapVDPro/index.vue